<template>
  <div>
    <Button
      :size="15"
      color="#2da44e"
      colorText="#ffffff"
      tooltip="Agregar Acuerdo"
      icon="fas fa-plus"
      round
      :width="30"
      class="mt-2 mb-3 mr-2"
      traslate
      @click.native="openModal('modal');"
    />
    <ui-modal
      ref="modal"
      size="auto"
      class="modal-agregar-acuerdo-linea"
      title="Agregar Acuerdo de Línea"
      @close="ActionSetZindexModal(false),ActionSetZindexTablaModal(false)"
    >
      <div class="acuerdo-lineas-modal__container">
        <div class="acuerdo-lineas-modal__container-header">
          <acuerdo-lineas-form-component :form="addAcuerdoLineasForm"  />
        </div>

      <div class="d-flex justify-content-between acuerdo-lineas-modal__container-footer">
        <button class="btn btn-default" @click="closeModal('modal')">
          Cerrar
        </button>
        <div style="float: right">
          <button
            class="btn btn-secondary"
            style="margin-right: 15px"
            @click="resetearCampos()"
          >
            Limpiar
          </button>
          <button
            class="btn btn-outline-primary"
            id="buttonRef"
            @click="validarFormulario"
          >
            Agregar
          </button>
        </div>
      </div>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Vue
import Vue from "vue";
// Vuex
import { mapActions, mapState } from "vuex";
// Toast
import VueToastify from "vue-toastify";
Vue.use(VueToastify);

// UI Modal
import UiModal from "keen-ui/src/UiModal";

// Constantes
import { crearAcuerdoLinea, getAcuerdosLineas } from "@/constants/lineas";

// Buttom
import Button from "../../../../common/Button";
import AcuerdoLineasFormComponent from "./AcuerdoLineasFormComponent";
// import { acuerdoLineasFormConstant } from "../../../../../constants/forms";

export default {
  props: [ "getListaAcuerdosLineas"],
  data() {
    return {
      addAcuerdoLineasForm: {
        id: {
          value: ""
        },
        naviera_id: {
          value: {
            id: "",
            name: ""
          }
        },
        naviera_salida: {
          value: {
            id: "",
            name: ""
          }
        },
        pol: {
          value: {
            id: "",
            name: ""
          }
        },
        pod: {
          value: {
            id: "",
            name: ""
          }
        },
        atmosphere_id: {
          value: {
            id: "",
            name: ""
          }
        },
        coldtreatment: {
          value: {
            id: "",
            name: ""
          }
        },
        container_id: {
          value: {
            id: "",
            name: ""
          }
        },
        products_category_id: {
          value: {
            id: "",
            name: ""
          }
        },
        from_date: {
          value: ""
        },
        to_date: {
          value: ""
        },
        transit_time: {
          value: ""
        },
        neta: {
          value: ""
        },
        public_value: {
          value: ""
        },
        contract: {
          value: ""
        },
        free_days_land: {
          value: ""
        },
        plug_days_land: {
          value: ""
        },
        genset: {
          value: false
        },
        get_out: {
          value: false
        },
        comment: {
          value: ""
        },
        country_id: {
          value: ""
        },
        id_by_country: {
          value: ""
        },
        tariff_contract_id: {
            value: {
                id: "",
                name: ""
            }
        },
        free_days_embark: {
          value: ""
        },
        plug_days_embark: {
          value: ""
        },
        type_contract: {
            value: {
                id: "",
                name: ""
            }
        },
        navieras_salida_list: []
      }
    };
  },
  components: {
    UiModal,
    Button,
    AcuerdoLineasFormComponent,
  },
  computed: {
    ...mapState([
      "navieras",
      "tipoContratos"
    ]),

    ...mapState("lineas", [
      "dataListaPOD",
      "dataListaPOL",
      "dataListaProducto",
      "dataContenedores",
      "listaAtmosferas",
    ]),
  },
  methods: {
    ...mapActions([
      "ActionSetZindexModal",
    "ActionSetZindexTablaModal"]),

    ...mapActions("lineas", [
      "actionSetDataListarTarifasAcuerdosLineas"
    ]),
    resetearCampos() {
      this.addAcuerdoLineasForm = {
        id: {
          value: "",
        },
        naviera_id: {
          value: {
            id: "",
            name: "",
          },
        },
        naviera_salida: {
          value: {
            id: "",
            name: "",
          },
        },
        pol: {
          value: {
            id: "",
            name: "",
          },
        },
        pod: {
          value: {
            id: "",
            name: "",
          },
        },
        atmosphere_id: {
          value: {
            id: "",
            name: "",
          },
        },
        coldtreatment: {
          value: {
            id: "",
            name: "",
          },
        },
        container_id: {
          value: {
            id: "",
            name: "",
          },
        },
        products_category_id: {
          value: {
            id: "",
            name: "",
          },
        },
        from_date: {
          value: "",
        },
        to_date: {
          value: "",
        },
        transit_time: {
          value: "",
        },
        neta: {
          value: 0,
        },
        public_value: {
          value: 0,
        },
        contract: {
          value: "",
        },
        free_days_land: {
          value: "",
        },
        plug_days_land: {
          value: "",
        },
        genset: {
          value: false,
        },
        get_out: {
          value: false,
        },
        comment: {
          value: "",
        },
        country_id: {
          value: "",
        },
        id_by_country: {
          value: "",
        },
        tariff_contract_id: {
          value: {
            id: "",
            name: "",
          },
        },
        free_days_embark: {
          value: "",
        },
        plug_days_embark: {
          value: "",
        },
        type_contract: {
          value: {
            id: "",
            name: "",
          },
        },
        navieras_salida_list: []
      };
    },
    openModal(ref) {
      this.ActionSetZindexModal(true);
      this.ActionSetZindexTablaModal(true);
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.ActionSetZindexModal(false);
      this.ActionSetZindexTablaModal(false);
      this.$refs[ref].close();
    },
    estadoButton(text, estado = true) {
      let buttonRef = document.querySelector("#buttonRef");
      buttonRef.innerHTML = text;
      buttonRef.disabled = estado;
    },
    cerrarModal() {
      this.ActionSetZindexModal(false);
      this.ActionSetZindexTablaModal(false);
    },
    async validarFormulario() {
      if (this.addAcuerdoLineasForm.naviera_id.value.id === "") {
        this.$vToastify.error("Campo Naviera vacío", "¡Error!");
        return;
      }
      if (this.addAcuerdoLineasForm.naviera_salida.value.id === "") {
        this.$vToastify.error("Campo Naviera Salida vacío", "¡Error!");
        return;
      }
      if (this.addAcuerdoLineasForm.pol.value.id === "") {
        this.$vToastify.error("Campo POL vacío", "¡Error!");
        return;
      }
      if (this.addAcuerdoLineasForm.pod.value.id == "") {
        this.$vToastify.error("Campo POD vacío", "¡Error!");
        return;
      }
      if (this.addAcuerdoLineasForm.from_date.value == "") {
        this.$vToastify.error("Campo DESDE vacío", "¡Error!");
        return;
      }
      if (this.addAcuerdoLineasForm.to_date.value == "") {
        this.$vToastify.error("Campo HASTA vacío", "¡Error!");
        return;
      }
      if (this.addAcuerdoLineasForm.transit_time.value == "") {
        this.$vToastify.error("Campo TT vacío", "¡Error!");
        return;
      }
      if (!this.addAcuerdoLineasForm.neta.value) {
        this.$vToastify.error("Campo Neta vacío", "¡Error!");
        return;
      }
      if (!this.addAcuerdoLineasForm.public_value.value) {
        this.$vToastify.error("Campo Pública (Venta) vacío", "¡Error!");
        return;
      }
      if (this.addAcuerdoLineasForm.container_id.value.id === "") {
        this.$vToastify.error("Campo Unidad vacío", "¡Error!");
        return;
      }
      if (this.addAcuerdoLineasForm.products_category_id.value.id === "") {
        this.$vToastify.error("Campo Commodity vacío", "¡Error!");
        return;
      }
      if (this.addAcuerdoLineasForm.atmosphere_id.value.id === "") {
        this.$vToastify.error("Campo Atmósfera vacío", "¡Error!");
        return;
      }
      if (this.addAcuerdoLineasForm.free_days_embark.value == "") {
        this.$vToastify.error("Campo Free Days Origen vacío", "¡Error!");
        return;
      }
      if (this.addAcuerdoLineasForm.plug_days_embark.value == "") {
        this.$vToastify.error("Campo Plug Days Origen vacío", "¡Error!");
        return;
      }
      if (this.addAcuerdoLineasForm.free_days_land.value == "") {
        this.$vToastify.error("Campo Free Days Destino vacío", "¡Error!");
        return;
      }
      if (this.addAcuerdoLineasForm.plug_days_land.value == "") {
        this.$vToastify.error("Campo Plug Days Destino vacío", "¡Error!");
        return;
      }

      if (this.addAcuerdoLineasForm.type_contract.value.id == "") {
        this.$vToastify.error("Campo Tipo Contrato vacío", "¡Error!");
        return;
      }

      if ( this.addAcuerdoLineasForm.tariff_contract_id.value.id === "" || 
            this.addAcuerdoLineasForm.tariff_contract_id.value.id === undefined ) {
        this.$vToastify.error("Campo Contrato no debe estar vacío", "¡Error!");
        return;
      }
      await this.guardar();
    },
    async loadingData() {
      const { data_table } = await getAcuerdosLineas();
      this.actionSetDataListarTarifasAcuerdosLineas( data_table );
    },
    async guardar() {
      let tariff_lines = [];

      this.estadoButton("Agregando...");

      this.$vToastify.loader("Agregando Acuerdo de Líneas...");

      tariff_lines.push({
        atmosphere_id: this.addAcuerdoLineasForm.atmosphere_id.value.id,
        coldtreatment:
          typeof this.addAcuerdoLineasForm.coldtreatment.value === "object"
            ? (this.addAcuerdoLineasForm.coldtreatment.value.name || "")
            : (this.addAcuerdoLineasForm.coldtreatment.value || ""),
        comment: this.addAcuerdoLineasForm.comment.value,
        container_id: this.addAcuerdoLineasForm.container_id.value.id,
        contract: this.addAcuerdoLineasForm.contract.value,
        country_id: this.addAcuerdoLineasForm.country_id.value,
        free_days_embark: this.addAcuerdoLineasForm.free_days_embark.value,
        free_days_land: this.addAcuerdoLineasForm.free_days_land.value,
        from_date: this.addAcuerdoLineasForm.from_date.value,
        genset: this.addAcuerdoLineasForm.genset.value,
        get_out: this.addAcuerdoLineasForm.get_out.value,
        id: this.addAcuerdoLineasForm.id.value,
        id_by_country: this.addAcuerdoLineasForm.id_by_country.value,
        naviera_id: this.addAcuerdoLineasForm.naviera_id.value.id,
        naviera_salida_id: this.addAcuerdoLineasForm.naviera_salida.value.id,
        neta: this.addAcuerdoLineasForm.neta.value,
        plug_days_embark: this.addAcuerdoLineasForm.plug_days_embark.value,
        plug_days_land: this.addAcuerdoLineasForm.plug_days_land.value,
        pod: this.addAcuerdoLineasForm.pod.value.id,
        pol: this.addAcuerdoLineasForm.pol.value.id,
        products_category_id:
          this.addAcuerdoLineasForm.products_category_id.value.id,
        public_value: this.addAcuerdoLineasForm.public_value.value,
        tariff_contract_id:
          this.addAcuerdoLineasForm.tariff_contract_id.value.id,
        to_date: this.addAcuerdoLineasForm.to_date.value,
        transit_time: this.addAcuerdoLineasForm.transit_time.value,
        type_contract: this.addAcuerdoLineasForm.type_contract.value.id,
      });

      let dataParaEnviar = { tariff_lines };

      let sql = await crearAcuerdoLinea(dataParaEnviar);
      this.estadoButton("Agregar", false);

      this.$vToastify.stopLoader();

      if (!sql.error) {
        // Toast proceso exitoso
        this.loadingData();
        this.$vToastify.success(
          "Acuerdo de linea creado con éxito",
          "¡Realizado!"
        );

        this.resetearCampos();
        this.closeModal("modal");
      } else {
        if (sql.data.length > 0) {
          // Errores de validación
          sql.data.map((item) => {
            this.$vToastify.error(`${item}`);
          });
        } else {
          // Proceso erroneo
          this.$vToastify.error(
            "El Acuerdo de linea no pudo ser creado",
            "¡Error!"
          );
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @mixin fullStretch(){
    width: 100%;
    height: 100%;
  }

  .acuerdo-lineas-modal__container {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 200px 50px;

    &-header {
      @include fullStretch();
      grid-column: 1/2;
      grid-row: 1/2;
      overflow-x: auto;
    }

    &-footer {
      @include fullStretch();
      grid-column: 1/2;
      grid-row: 3/4;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .selected-table-row {
    background-color: aquamarine;
  }

</style>
